// Guards de navegação extraídos de main.js para poderem ser testados
// isoladamente, sem precisar montar o router + Pinia inteiros.

// Decide se uma rota pode ser acessada por um admin sem vínculo, a partir do
// próprio `meta` da rota (e das rotas pai, via `to.matched`) — ver
// ADMIN_UNLINKED_ALLOWED_PATHS na task 86akftj33.
export function canUnlinkedAdminAccess(to) {
  return to.matched.some(record => record.meta.adminUnlinked)
}

// Perspectiva do admin vinculado derivada da rota: /admin/* é a visão admin; rota
// de cliente é a visão cliente. Rotas compartilhadas (meta.adminUnlinked: /user,
// /link, notificações...) não trocam a visão (task 86akqpnf2).
export function resolvePerspective(to, current) {
  if (to.matched.some(record => record.meta.admin)) return 'admin'
  if (canUnlinkedAdminAccess(to)) return current
  return 'client'
}

// Telas admin sem dado do cliente vinculado (ex.: onboarding pendente ainda não
// pertence a um Client). Com vínculo ativo, voltam para o painel.
export function isHiddenForLinkedAdmin(to) {
  return to.matched.some(record => record.meta.hiddenForLinkedAdmin)
}
